/* eslint-disable no-console */
import { useDispatch } from 'react-redux';
import { OAuthProviders } from '../oauth/OAuthProviders';
import { oAuthAuthFailed, oAuthAuthStarted, oAuthAuthSucceeded, verifyOAuthVerificationPayload } from '../store/oauth/action-creators';
import { msalConfig } from './utils/msalConfig';
export const useMicrosoft = () => {
  const microsoftApp = new window.msal.PublicClientApplication(msalConfig);
  const dispatch = useDispatch();
  const provider = OAuthProviders.Microsoft;

  const onClick = () => {
    dispatch(oAuthAuthStarted(provider));
    microsoftApp.loginPopup({
      prompt: 'select_account'
    }).then(({
      accessToken
    }) => {
      dispatch(oAuthAuthSucceeded({
        token: accessToken
      }, provider));
      dispatch(verifyOAuthVerificationPayload(accessToken, provider));
    }).catch(error => {
      dispatch(oAuthAuthFailed(error, provider));
    });
  };

  return {
    onClick
  };
};